import React, { useState } from "react";
import { Button, Card, Input } from "antd";
import message from "../../components/Message";
import "./index.css";

export default function PasswordChangeModule() {
  const [loading, setLoading] = useState(false);
  const [account, setAccount] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8080";

  const handleSave = async () => {
    if (loading) return;
    if (!account.trim()) {
      message.toast("请输入账号");
      return;
    }
    if (!oldPassword.trim()) {
      message.toast("请输入旧密码");
      return;
    }
    if (!newPassword.trim()) {
      message.toast("请输入新密码");
      return;
    }
    setLoading(true);
    try {
      const params = new URLSearchParams({
        account,
        oldPassword,
        newPassword,
      });
      const resp = await fetch(`${baseUrl}/admin/password/change?${params}`);
      const result = await resp.json();
      const { code, msg } = result || {};
      if (code) {
        message.toast(msg || "修改失败");
        return;
      }
      message.success("修改成功");
      setOldPassword("");
      setNewPassword("");
    } catch (error) {
      message.toast("修改失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        minHeight: "100%",
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card title="修改密码" style={{ maxWidth: 420, width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <div style={{ marginBottom: 6, fontSize: 14, color: "#6b7280" }}>
              <span style={{ color: "#ef4444", marginRight: 4 }}>*</span>
              账号
            </div>
            <Input
              placeholder="请输入账号"
              autoComplete="off"
              value={account}
              onChange={(event) => setAccount(event.target.value)}
              onPressEnter={handleSave}
            />
          </div>
          <div>
            <div style={{ marginBottom: 6, fontSize: 14, color: "#6b7280" }}>
              <span style={{ color: "#ef4444", marginRight: 4 }}>*</span>
              旧密码
            </div>
            <Input.Password
              placeholder="请输入旧密码"
              autoComplete="new-password"
              value={oldPassword}
              onChange={(event) => setOldPassword(event.target.value)}
              onPressEnter={handleSave}
            />
          </div>
          <div>
            <div style={{ marginBottom: 6, fontSize: 14, color: "#6b7280" }}>
              <span style={{ color: "#ef4444", marginRight: 4 }}>*</span>
              新密码
            </div>
            <Input.Password
              placeholder="请输入新密码"
              autoComplete="new-password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              onPressEnter={handleSave}
            />
          </div>
          <Button
            type="primary"
            loading={loading}
            onClick={handleSave}
            size="large"
            style={{ marginTop: 6, marginBottom: 6 }}
          >
            保存
          </Button>
        </div>
      </Card>
    </div>
  );
}
